import CatalogMenu from './cmpt/catalogMenu/CatalogMenu';
import Icons from '../utils/Icons';
import SiteMenu from '../utils/SiteMenu';
import MobileContacts from '../utils/MobileContacts';
import CallbackForm from '../utils/CallbackForm';
import { SearchWidget } from '../utils/SearchWidget';

window.toCart = () => (window.location.href = '/cart');
window.toCompare = () => (window.location.href = '/compare');
window.toFav = () => (window.location.href = '/favorites');

export const RunCommon = () => {
  window.addEventListener('load', () => {
    CatalogMenu();
    SiteMenu();
    MobileContacts();
    Icons();
    SearchWidget('desktop-search');
    CallbackForm(
      [
        'show-callback',
        'show-callback-scroll',
        'show-callback-footer',
        'show-callback-mob',
      ],
      'Заказать звонок',
      'order_callback',
      null,
    );
  });
};
